import { Badge, Card, Col, Container, Form, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, Row, UncontrolledTooltip, FormGroup } from "reactstrap";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Button, CardBody } from 'reactstrap';
import { forwardRef, InputHTMLAttributes, useCallback, useEffect, useState } from 'react';
import webservice from '../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from "../../../Service/crypto";
import { ChevronLeft, ChevronRight, Edit, Eye, EyeOff, Trash, Trash2, RefreshCw } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import DataTable from "react-data-table-component";
import moment from "moment-timezone";
import { useForm } from "react-hook-form";
import MD5 from "crypto-js/md5";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from 'yup';
import { getData, Get_permission } from './store'
import { useAppDispatch } from '../../../ReaduxToolkit/Hooks';
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import websocket_webservice from '../../../Service/websocket_webservice'
import api from '../../../api';
import ColumnChooser, { ColumnOption, isColVisible } from '../../../Components/ColumnChooser/ColumnChooser';
import { useColumnPreferences } from '../../../hooks/useColumnPreferences';


const CustomHeader = ({ menuActions, handleFilter, value, handlePerPage, rowsPerPage, columnOptions, savedColumns, onColumnsChange }: any) => {
  return (
    <div className='client-master-list-table-header w-100 py-2'>
      <Row>
        <Col lg='6' className='d-flex align-items-center px-0 px-lg-1'>
          <div className='d-flex align-items-center me-4 '>
            <label htmlFor='rows-per-page' className='me-2'>Rows per Page:</label>
            <Input
              type='select'
              id='rows-per-page'
              value={rowsPerPage}
              onChange={handlePerPage}
              className='form-control ms-50 larger-select '
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
            </Input>
          </div>
          {menuActions.includes('add') && (
            <Button tag={Link} to='/userManagement/addUser' color='primary' className='ms-2 zoom-on-hover'>
              + Add User
            </Button>
          )}
        </Col>
        <Col
          lg='6'
          className='d-flex align-items-center justify-content-lg-end mt-lg-0 mt-1 px-0 px-lg-3'
        >
          <div className="mb-2 me-2">
            <ColumnChooser options={columnOptions} savedColumns={savedColumns} onChange={onColumnsChange} />
          </div>
          <InputGroup className="input-group-search mb-2 zoom-on-hover">
            <Input
              type="text"
              placeholder="🔍 Search...."
              value={value}
              onChange={(e) => handleFilter(e.target.value)}
              className="input-search"
            />
          </InputGroup>
        </Col>
      </Row>
    </div>
  );
};



const UserManagement = () => {
  interface DeleteRowData {
    id: string;
    firstName: string;
    lastName: string;
    emailId: string;
    UserName: string;
    user_type: string;
    RefId: string;
    otp_enabled?: boolean;
    is_two_factor_enabled?: boolean;
  }

  const navigate = useNavigate();


  const [scrollInnerModal, setScrollInnerModal] = useState<boolean>(false);
  const [filteredAuditData, setFilteredAuditData] = useState<any[]>([]);
  const [refid, setRefid] = useState<string | null>(null);
  const Username = localStorage.UserName;
  const Role = localStorage.Role;
  // MFA controls are visible only to Super Admin and Dev Admin
  const canManageMfa = Role === 'Super Admin' || Role === 'Dev Admin' || Username === 'DevAdmin';
  const action = { fromUser: true };
  const [eventId, setEventId] = useState<DeleteRowData[]>([]);
  const [eventId1, setEventId1] = useState(0);
  const selectedRowsPerPage: { [key: number]: DeleteRowData[] } = {};
  // const menuActions = ['add','delete'];
  const [isOpen, setIsOpen] = useState(false);

  const dispatch = useAppDispatch()
  const store = useSelector((state: any) => state.UserManagement)
  const [value, setValue] = useState<string>('');
  const [sort, setSort] = useState<string>('desc');
  const [sortColumn, setSortColumn] = useState<any>('created_date'); // Example initial sort column
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  const [menuActions, setMenuActions] = useState<string>('');

  const Id = localStorage.id;
  const UserType = localStorage.UserType;

  useEffect(() => {
    if (Id !== null) {
      dispatch(Get_permission(Id)).then((response) => {
        const res1 = response.payload;
        const Action = res1[0].Permission.filter(
          (item: any) => item.MenuKey === "USER_MANAGEMENT"
        );
        setMenuActions(Action[0].MenuActions);
      });
    }
  }, [Id])


  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const defaultValues = {
    confirmPassword: "",
    newPassword: ""
  }

  const {
    handleSubmit,
    formState: { errors },
    reset,

    control, watch
  } = useForm({
    defaultValues,
  });


  // useEffect(() => {
  //   dispatch(
  //     getData({
  //       Id,
  //       UserType,
  //       Role,
  //       q: value,
  //       perPage: rowsPerPage,
  //       page: currentPage,
  //       sort,
  //       sortColumn
  //     })
  //   );
  // }, [dispatch, store.data.length, value, rowsPerPage, currentPage, sortColumn ,Id,UserType,]);

  const [localData, setLocalData] = useState<DeleteRowData[]>(store.data);

  // Define fetchData outside useEffect for better readability (optional)
  const fetchData = async () => {
    try {
      if (Id && UserType) {
        const actionResult = await dispatch(
          getData({
            Id,
            UserType,
            q: value,
            perPage: rowsPerPage,
            page: currentPage,
            sort,
            sortColumn,
          })
        );

        const payload = actionResult.payload as { data: DeleteRowData[] };
        setLocalData(payload.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch data when dependencies change
  useEffect(() => {
    fetchData();
  }, [dispatch, Id, UserType, rowsPerPage, currentPage, sort, sortColumn, value]);

  // WebSocket for live updates
  useEffect(() => {
    const socket = new WebSocket(`${websocket_webservice}ws/usermanagement/`);

    socket.onmessage = (event) => {
      const change = JSON.parse(event.data);

      setLocalData((prevData: DeleteRowData[]) =>
        prevData.map((item) =>
          item.id === change.documentKey._id.$oid
            ? { ...item, ...change.updateDescription.updatedFields }
            : item
        )
      );
    };

    return () => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    };
  }, [websocket_webservice]);


  const handleReloadTable = () => {
    dispatch(
      getData({
        Id,
        UserType,
        Role,
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn
      })
    );
  };


  const handleFilter = (val: any) => {
    setValue(val)
    setCurrentPage(1)
    dispatch(
      getData({
        Id,
        UserType,
        Role,
        q: val,
        perPage: rowsPerPage,
        page: currentPage,
        sort,
        sortColumn,
      })
    )
  }

  const handlePerPage = (e: any) => {
    setCurrentPage(1)
    dispatch(
      getData({
        Id,
        UserType,
        Role,
        q: value,
        perPage: parseInt(e.target.value),
        page: currentPage,
        sort,
        sortColumn,
      })
    )
    setRowsPerPage(parseInt(e.target.value))
  }



  const handlePagination = (page: any) => {
    dispatch(
      getData({
        Id,
        UserType,
        Role,
        q: value,
        perPage: rowsPerPage,
        page: page.selected + 1,
        sort,
        sortColumn,
      })
    )
    setCurrentPage(page.selected + 1)
  }


  const dataToRender = () => {
    const filters: any = {
      q: value
    };
    const isFiltered = Object.keys(filters).some(function (k) {
      return filters[k].length > 0;
    });

    if (localData.length > 0) {
      return localData;
    } else if (localData.length === 0 && isFiltered) {
      return [];
    } else {
      return store.allData.slice(0, rowsPerPage);
    }
  };

  const handleSort = (column: any, sortDirection: any) => {
    setSort(sortDirection)
    setSortColumn(column.sortField)
    dispatch(
      getData({
        Id,
        UserType,
        Role,
        q: value,
        perPage: rowsPerPage,
        page: currentPage,
        sort: sortDirection,
        sortColumn: column.sortField
      })
    )
  }

  const CustomPagination = () => {
    const count = Number(Math.ceil(store.total / rowsPerPage))

    return (
      <ReactPaginate
        previousLabel={<ChevronLeft size={16} />}
        nextLabel={<ChevronRight size={16} />}
        breakLabel="..."
        pageCount={count || 1}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        onPageChange={handlePagination}
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        containerClassName="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakClassName="page-item"
        breakLinkClassName="page-link"
        activeClassName="active"
      />
    )
  }

  const handleSave = (async (data: FormValues) => {
    const key = await keyPromise
    const newPassword = data.newPassword
    const hashedPassword = MD5(newPassword).toString();
    const resetpassword: any = { hashedPassword, refid };
    const EncParams = await AesEncrypt(key, resetpassword);
    await api.fetch('api/Authentication/ResetPassword', {
      method: 'POST',
      body: JSON.stringify(EncParams)
    })
      .then((response) => {
        toggle();
        if (response.ok) {
          Swal.fire({
            title: 'Insurance Verification',
            text: 'Password successfully changed',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.isConfirmed) {
              navigate(`/userManagement`);
            }
          });
        } else {
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });


  const ViewAuditLog = async (row: any) => {
    const Username = localStorage.UserName;
    const Userid = localStorage.id;
    const RefId = row.RefId;
    const Name = row.UserName;
    const Data = { Username, RefId, Name, Userid };
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, Data);
    const response = await api.fetch('api/usermanagement/ViewAuditLog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    return response;
  };

  const deleteClient = async (ids: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, ids);
    await api.fetch('api/usermanagement/delete', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
  };

  const DeleteAuditLogdata = async (Data: any) => {
    Data.Userid = localStorage.id;
    Data.ParentUserId = localStorage.ParentUserId;
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, Data);
    const response = await api.fetch('api/usermanagement/DeleteAuditLog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    return response;
  };


  const DeleteRow = async (rows: DeleteRowData[] | DeleteRowData) => {

    const deleteRows = async () => {
      const rowCount = Array.isArray(rows) ? rows.length : 1;
      Swal.fire({
        title: "Insurance Verification Platform",
        text: `Are you sure you want to delete ${rowCount} ${rowCount > 1 ? 'User' : 'User'}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger ms-1",
        },
        buttonsStyling: false,
        allowOutsideClick: false
      }).then(async function (result) {
        if (result.isConfirmed) {
          if (Array.isArray(rows)) {
            const ids = rows.map(row => row.id);

            const Data = rows.map(row => ({
              Username,
              RefId: row.RefId,
              Name: row.UserName
            }));
            await deleteClient(ids);
            await DeleteAuditLogdata(Data);
            // ✅ Remove deleted rows from localData
            setLocalData(prev => prev.filter(item => !ids.includes(item.id)));
          } else {
            const { id, UserName: Name, RefId } = rows;
            const Data = { Username, RefId, Name };
            await deleteClient([id]);
            await DeleteAuditLogdata([Data]);
            // ✅ Remove the deleted row from localData
            setLocalData(prev => prev.filter(item => item.id !== id));
          }
          fetchData()
          Swal.fire({
            icon: "success",
            title: "Insurance Verification Platform",
            text: "User have been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
            allowOutsideClick: false
          });
          handleReloadTable();
          setEventId1(0)
          setEventId([])
        }
      });
    };
    deleteRows();
  };


  const getAuditlogdata = async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, data);
    const response = await api.fetch('api/usermanagement/getAuditlogdata', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key, response);
    return TempData;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (refid !== null) {
        const res = await getAuditlogdata(refid);
        setFilteredAuditData(res);
      }
    };
    fetchData();
  }, [refid]);




  interface BootstrapCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
  }
  // Handle individual row checkbox change
  const BootstrapCheckbox = forwardRef<HTMLInputElement, BootstrapCheckboxProps>(
    ({ id, ...props }, ref) => (
      <div style={{ position: 'relative', left: '10px' }}>
        <input type='checkbox' id={id} ref={ref} {...props} />
      </div>
    )
  );

  const handleChangecheck = useCallback(
    ({ selectedRows }: any) => {

      const selectedEventIds = [];
      selectedRows.forEach((row: any) => {
        selectedEventIds.push(row.id);
      });
      setEventId(selectedRows)
      setEventId1(selectedEventIds.length)
      if (!action.fromUser)
        return;
      selectedRowsPerPage[currentPage] = selectedRows;
    },
    [currentPage, selectedRowsPerPage, action.fromUser]);



  // );

  const handleReset = () => {
    reset({
      confirmPassword: "",
      newPassword: ""
    })
    toggle()
  }

  const handleResetMFA = async (row: DeleteRowData) => {
    Swal.fire({
      title: "Reset MFA",
      text: `Are you sure you want to reset MFA for ${row.firstName} ${row.lastName}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reset",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger ms-1",
      },
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const key = await keyPromise;
          const data = {
            userId: row.id
          };
          const EncParams = await AesEncrypt(key, data);

          const response = await api.fetch('api/Authentication/resetMFA', {
            method: 'POST',
            body: JSON.stringify({ EncParams })
          });

          const encryptedResponse = await response.json();
          const result = await AesDecrypt(key, encryptedResponse);

          if (result.success) {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: result.message || "MFA reset successfully",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            fetchData();
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed",
              text: result.message || "Failed to reset MFA",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        } catch (error) {
          console.error('Error resetting MFA:', error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An unexpected error occurred while resetting MFA",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
        }
      }
    });
  };

  const handleToggleMFA = async (row: DeleteRowData, enable: boolean) => {
    try {
      const key = await keyPromise;
      const data = {
        _id: row.id,
        enable: enable
      };
      const EncParams = await AesEncrypt(key, data);

      const response = await api.fetch('api/Authentication/toggleMFA', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      const encryptedResponse = await response.json();
      const result = await AesDecrypt(key, encryptedResponse);


      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: result.message || `MFA ${enable ? 'enabled' : 'disabled'} successfully`,
          customClass: {
            confirmButton: "btn btn-success",
          },
          timer: 2000,
          showConfirmButton: false
        });
        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: result.message || "Failed to toggle MFA",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
        fetchData(); // Refresh to revert toggle state
      }
    } catch (error) {
      console.error('Error toggling MFA:', error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred while toggling MFA",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      fetchData(); // Refresh to revert toggle state
    }
  };

  const Columns = [
    {
      id: "FirstName",
      name: "First Name",
      selector: (row: DeleteRowData) => row.firstName,
      sortable: true,
    },
    {
      id: "LastName",
      name: "Last Name",
      selector: (row: DeleteRowData) => row.lastName,
      sortable: true,
    },
    {
      id: "EmailID",
      name: "Email ID",
      selector: (row: DeleteRowData) => row.emailId,
      sortable: true,
      width: "240px",
      wrap: true,
    },
    {
      id: "Username",
      name: "Username",
      selector: (row: DeleteRowData) => row.UserName,
      sortable: true,
    },
    {
      id: "UserType",
      name: "User Type",
      selector: (row: DeleteRowData) => row.user_type,
      sortable: true,
    },
    {
      id: "MFA",
      name: "MFA",
      cell: (row: DeleteRowData) => (

        <div className="form-check form-switch">
          <Input
            type="switch"
            id={`mfa-switch-${row.id}`}
            checked={row.is_two_factor_enabled || false}
            onChange={(e) => handleToggleMFA(row, e.target.checked)}
            disabled={!menuActions.includes("edit")}
            style={{ cursor: menuActions.includes("edit") ? 'pointer' : 'not-allowed' }}
          />
          <UncontrolledTooltip placement="top" target={`mfa-switch-${row.id}`} style={{ backgroundColor: "#355876", color: "white" }}>
            {row.is_two_factor_enabled ? 'MFA Enabled' : 'MFA Disabled'}
          </UncontrolledTooltip>
        </div>
      ),
      sortable: false,
      width: "120px",
      omit: !canManageMfa,
    },
    {
      id: "ResetMFA",
      name: "Reset MFA",
      cell: (row: DeleteRowData) => (
        <>
          {menuActions.includes("edit") && row.otp_enabled && (
            <>
              <RefreshCw
                size={17}
                id={`reset-mfa-${row.id}`}
                color='#FF6B6B'
                onClick={() => handleResetMFA(row)}
                style={{ cursor: 'pointer' }}
              />
              <UncontrolledTooltip placement="top" target={`reset-mfa-${row.id}`} style={{ backgroundColor: "#355876", color: "white" }}>
                Reset MFA
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
      sortable: false,
      width: "120px",
      omit: !canManageMfa,
    },
    {
      id: "Action",
      name: "Action",
      cell: (row: DeleteRowData) => (
        <>
          <>
            <Eye
              size={17}
              id='positionLeft'
              color='#09d5ff'
              onClick={() => {
                setScrollInnerModal(true);
                setRefid(row.RefId);
              }}
              style={{ cursor: 'pointer', marginRight: '10px' }}
            />
            <UncontrolledTooltip placement="top" target='positionLeft' style={{ backgroundColor: "#355876", color: "white" }}>
              Audit log
            </UncontrolledTooltip>
          </>
          {eventId1 <= 1 && (
            menuActions.includes("edit") && (
              <>
                <Edit size={17}
                  id='editIcon'
                  color='#FFA500'
                  onClick={() => {
                    ViewAuditLog(row);
                    navigate(`/userManagement/editUser`)
                    localStorage.setItem("UserEdit", row.RefId)
                  }}
                  style={{ cursor: 'pointer', marginRight: '10px' }} />
                <UncontrolledTooltip placement="top" target='editIcon' style={{ backgroundColor: "#355876", color: "white" }}>
                  Edit
                </UncontrolledTooltip>
              </>
            )
          )}
          {eventId1 === 0 && (
            menuActions.includes("delete") && (
              <>
                <Trash2 size={17} id='deleteIcon' color='#FF0000' onClick={() => DeleteRow(row)} style={{ cursor: 'pointer' }} />
                <UncontrolledTooltip placement="top" target='deleteIcon' style={{ backgroundColor: "#355876", color: "white" }}>
                  Delete
                </UncontrolledTooltip>
              </>
            )
          )}
        </>
      ),

    },
  ];



  if (Role === 'Admin' || 'Super Admin') {
    const passwordColumn: any = {
      sortable: true,
      id: 'Password',
      name: 'Password',
      selector: (row: DeleteRowData) => (
        <div className="badge-icon">
          <Badge
            style={{ cursor: 'pointer' }}
            className="badge-button "
            onClick={() => {
              setRefid(row.RefId);
              setIsOpen(true);
            }}
          >
            Reset
          </Badge>
        </div>
      )
    };
    Columns.splice(5, 0, passwordColumn);
  }

  const { savedColumns, saveColumns } = useColumnPreferences('UserManagementListing');
  const columnOptions: ColumnOption[] = Columns.filter((c) => !c.omit).map((c) => ({ id: c.id, label: c.name, locked: c.id === 'FirstName' || c.id === 'Action' }));
  const visibleColumns = Columns.filter((c) => isColVisible(columnOptions, savedColumns, c.id));

  const customStyles = {

    rows: {
      style: {

        '&:hover': {
          backgroundColor: '#f0f0f0',
        },
      },
    },

    headCells: {
      style: {
        backgroundColor: '#355876',
        color: 'white',
        fontSize: '16px',
      },
    },
  };


  interface FormValues {
    newPassword: string;
    confirmPassword: string;
  }

  const initialValues: FormValues = {
    newPassword: '',
    confirmPassword: '',
  };

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string().required('New Password field is required.'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), ''], 'Passwords must match')
      .required('This field is required.'),
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);



  const startIndex = (currentPage - 1) * rowsPerPage + 1;
  const endIndex = Math.min(currentPage * rowsPerPage, store.total);
  const CustomLoadingComponent = () => {
    return (
      <div className="">
        {store.no_Data === 'There is no Record Found' ? (
          <h4>
            <br />
            <p>There are no records to display</p>
          </h4>
        ) : (
          <div className="custom-loader">
            <label className="custom-label">Please wait...</label>
            <div className="custom-loading"></div>
          </div>
        )}
      </div>
    );
  };


  return (
    <>
      <Breadcrumbs mainTitle='MOS Management' title='MOS Management' />
      <Container fluid>
        <div>
          <Modal isOpen={isOpen} toggle={toggle} className='modal-dialog-centered ' backdrop="static" >
            <ModalHeader style={{ fontWeight: 'bold' }}>Change Password</ModalHeader>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values: any) => handleSave(values)}
            >
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <ModalBody>
                    <Col>
                      <Label for="newPassword">New Password<span style={{ color: 'red' }}>*</span></Label>
                      <InputGroup>
                        <Field name="newPassword" placeholder="Enter your New Password" type={showPassword ? 'text' : 'password'} className="form-control" />
                        <InputGroupText className="cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <EyeOff size={14} style={{ cursor: 'pointer' }} /> : <Eye size={14} style={{ cursor: 'pointer' }} />}
                        </InputGroupText>
                      </InputGroup>
                      <ErrorMessage name="newPassword" component="span" className="text-danger" />
                    </Col>
                    <br />
                    <Col>
                      <Label for="confirmPassword">Confirm Password<span style={{ color: 'red' }}>*</span></Label>
                      <InputGroup>
                        <Field name="confirmPassword" placeholder=" Re-Enter your Password" type={showConfirmPassword ? 'text' : 'password'} className="form-control" />
                        <InputGroupText className="cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? <EyeOff size={14} style={{ cursor: 'pointer' }} /> : <Eye size={14} style={{ cursor: 'pointer' }} />}
                        </InputGroupText>
                      </InputGroup>
                      <ErrorMessage name="confirmPassword" component="span" className="text-danger" />
                    </Col>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" type="submit">
                      Save
                    </Button>
                    <Button color="danger" type="reset" onClick={handleReset}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </Modal>
        </div>
        <div>
          <Modal style={{ maxWidth: '1500px', maxHeight: '600px' }} isOpen={scrollInnerModal} toggle={() => setScrollInnerModal(!scrollInnerModal)} className='modal-dialog-centered modal-lg'>
            <ModalHeader toggle={() => setScrollInnerModal(!scrollInnerModal)}>User Management Audit Log</ModalHeader>
            <ModalBody>
              <div style={{ maxHeight: '600px', overflow: 'auto' }}>
                {filteredAuditData.length > 0 ? (
                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f2f2f2' }}>
                        <th className="audit-tableHeaderStyle">Date & Time</th>
                        <th className="audit-tableHeaderStyle">Action</th>
                        <th className="audit-tableHeaderStyle">Data Set</th>
                        <th className="audit-tableHeaderStyle">Changed By</th>
                      </tr>
                    </thead>
                    <tbody style={{ alignItems: 'center' }}>
                      {filteredAuditData &&
                        filteredAuditData
                          .sort((a: any, b: any) => new Date(b.Modified).getTime() - new Date(a.Modified).getTime())
                          .map((item: any, index: number) => (
                            <tr key={index}>
                              <td className="audit-tableDataStyle">
                                {(() => {
                                  const localDate = moment.utc(item.Modified).tz(moment.tz.guess()).format('MM/DD/YYYY hh:mm:ss A');
                                  return localDate;
                                })()}
                              </td>
                              <td className="audit-tableDataStyle">{item.Action}</td>
                              <td className="audit-tableDataStyle">
                                {item.Action === 'VIEW' ? (
                                  <span>{item.JsonData}</span>
                                ) : (
                                  <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                    <thead>
                                      <tr style={{ backgroundColor: '#f2f2f2' }}>
                                        <th className="audit-tableHeaderStyle">Field</th>
                                        {item.Action === 'EDIT' && (
                                          <>
                                            <th className="audit-tableHeaderStyle">Before</th>
                                            <th className="audit-tableHeaderStyle">After</th>
                                          </>
                                        )}
                                        {item.Action === 'ADD' && (
                                          <th className="audit-tableHeaderStyle">Value</th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {item.JsonData
                                        .sort((a: any, b: any) => a.field.localeCompare(b.field))
                                        .map((dataItem: any, dataIndex: number) => (
                                          <tr key={dataIndex}>
                                            <td className="audit-tableDataStyle">{dataItem.field}</td>
                                            {item.Action === 'EDIT' && (
                                              <>
                                                <td className="audit-tableDataStyle">
                                                  {dataItem.field === 'Permission' && Array.isArray(dataItem.before) ? (
                                                    <table style={{ width: '100%' }}>
                                                      <thead>
                                                        <tr>
                                                          <th className="audit-tableHeaderStyle">Menu</th>
                                                          <th className="audit-tableHeaderStyle">Actions</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {dataItem.before.map((permission: any) => (
                                                          <tr key={permission.MenuLabel}>
                                                            <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                                                            <td className="audit-tableDataStyle">
                                                              {Array.isArray(permission.MenuActions)
                                                                ? permission.MenuActions.join(', ')
                                                                : permission.MenuActions}
                                                            </td>
                                                          </tr>
                                                        ))}
                                                      </tbody>
                                                    </table>
                                                  ) : (
                                                    (dataItem.before && dataItem.before.value) || dataItem.before
                                                  )}
                                                </td>
                                                <td className="audit-tableDataStyle">
                                                  {dataItem.field === 'Permission' && Array.isArray(dataItem.after) ? (
                                                    <table style={{ width: '100%' }}>
                                                      <thead>
                                                        <tr>
                                                          <th className="audit-tableHeaderStyle">Menu</th>
                                                          <th className="audit-tableHeaderStyle">Actions</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {dataItem.after.map((permission: any) => (
                                                          <tr key={permission.MenuLabel}>
                                                            <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                                                            <td className="audit-tableDataStyle">
                                                              {Array.isArray(permission.MenuActions)
                                                                ? permission.MenuActions.join(', ')
                                                                : permission.MenuActions}
                                                            </td>
                                                          </tr>
                                                        ))}
                                                      </tbody>
                                                    </table>
                                                  ) : (
                                                    (dataItem.after && dataItem.after.value) || dataItem.after
                                                  )}
                                                </td>
                                              </>
                                            )}
                                            {item.Action === 'ADD' && (
                                              <td className="audit-tableDataStyle">
                                                {dataItem.field === 'Password' || dataItem.field === 'Pin' ? (
                                                  '******'
                                                ) : dataItem.field === 'Permission' && Array.isArray(dataItem.value) ? (
                                                  <table style={{ width: '100%' }}>
                                                    <thead>
                                                      <tr>
                                                        <th className="audit-tableHeaderStyle">Menu</th>
                                                        <th className="audit-tableHeaderStyle">Actions</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {dataItem.value.map((permission: any) => (
                                                        <tr key={permission.MenuLabel}>
                                                          <td className="audit-tableDataStyle">{permission.MenuLabel}</td>
                                                          <td className="audit-tableDataStyle">
                                                            {Array.isArray(permission.MenuActions)
                                                              ? permission.MenuActions.join(', ')
                                                              : permission.MenuActions}
                                                          </td>
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                ) : (
                                                  (dataItem.value && dataItem.value.value) || dataItem.value
                                                )}
                                              </td>
                                            )}
                                          </tr>
                                        ))}
                                    </tbody>
                                  </table>
                                )}
                              </td>
                              <td className="audit-tableDataStyle">{item.UserName}</td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                ) : (
                  <div><center>No data available</center></div>
                )}
              </div>
            </ModalBody>
          </Modal>
        </div>
        <Row>
          <Col sm={12}>
            <Card >
              <CardBody>
                <div className="table-responsive">
                  <div className="dataTables_wrapper">
                    <DataTable
                      persistTableHead
                      subHeader={true}
                      responsive={true}
                      onSort={handleSort}
                      data={dataToRender()}
                      columns={visibleColumns}
                      paginationServer
                      customStyles={customStyles}
                      paginationPerPage={rowsPerPage}
                      paginationDefaultPage={currentPage}
                      selectableRows
                      selectableRowsHighlight
                      selectableRowsComponent={BootstrapCheckbox as unknown as React.ReactNode}
                      onSelectedRowsChange={handleChangecheck}
                      paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                      noDataComponent={<CustomLoadingComponent />}
                      paginationComponent={CustomPagination}
                      subHeaderComponent={
                        <CustomHeader
                          value={value}
                          menuActions={menuActions}
                          rowsPerPage={rowsPerPage}
                          handleFilter={handleFilter}
                          handlePerPage={handlePerPage}
                          columnOptions={columnOptions}
                          savedColumns={savedColumns}
                          onColumnsChange={saveColumns}
                        />
                      }
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ paddingLeft: '2%' }}>
                        {store.total && (
                          <span><strong>{`${startIndex} to ${endIndex} of ${store.total} entries`}</strong></span>
                        )}
                      </div>
                      <div>
                        <CustomPagination />
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <div>
              {eventId1 > 0 && menuActions.includes('delete') && (
                <div className="customizer-links open">
                  <Nav className=" flex-column nav-pills">
                    <a className="nav-link" onClick={() => DeleteRow(eventId)}>
                      <span>Delete</span>
                      <Trash2 className="trash-icon" size={20} />
                    </a>
                  </Nav>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );

};

export default UserManagement;
